import { render, staticRenderFns } from "./TheBaseFooter.vue?vue&type=template&id=12e43078&scoped=true&"
import script from "./TheBaseFooter.vue?vue&type=script&lang=js&"
export * from "./TheBaseFooter.vue?vue&type=script&lang=js&"
import style0 from "./TheBaseFooter.vue?vue&type=style&index=0&id=12e43078&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e43078",
  null
  
)

export default component.exports